import { ReactNode } from "react";

import { css } from "@compiled/react";
import { defineMessage, FormattedMessage, MessageDescriptor } from "react-intl";

import {
    getIdentityBaseUrl,
    getWacIntegrationUrl,
    getContinueParam
} from "@/components/signup/utils";
import { useUserContext } from "@/components/user-context";
import { Link } from "@/libraries/design/components";
import { BgColors } from "@/libraries/design/components/link/src/link";
import { useLocation } from "@/utils/location-provider";

const existingText = defineMessage({
    id: "BxpUiSignup.SignupForm.existingProduct",
    defaultMessage: "Already have {product}? <logInLink>Log in</logInLink>"
});

export const ExistingProductText = ({
    messageOverride,
    bgColor = "bgWhite"
}: {
    messageOverride?: MessageDescriptor;
    bgColor?: BgColors;
}) => {
    const { product } = useUserContext();
    const location = useLocation();
    const loginUrl = new URL("/login", getIdentityBaseUrl());
    const continueParam = getContinueParam(location);
    if (continueParam) {
        loginUrl.searchParams.append("continue", continueParam);
    } else {
        const defaultContinueUrl = new URL(
            "/gateway/api/start/authredirect",
            getWacIntegrationUrl()
        ).toString();
        loginUrl.searchParams.append("continue", defaultContinueUrl);
    }
    return (
        <p css={existingProductCss}>
            <FormattedMessage
                {...(messageOverride ?? existingText)}
                values={{
                    product: product?.name,
                    logInLink: (text: ReactNode) => (
                        <Link
                            text={text as unknown as string}
                            aria-label={text as unknown as string}
                            type="inline"
                            href={loginUrl.toString()}
                            bgColor={bgColor}
                            className="linkText"
                        />
                    )
                }}
            />
        </p>
    );
};

const existingProductCss = css({
    margin: "2rem 0 0 !important",
    textAlign: "center"
});
